export default {
    patentEditor: {
    // DraftingHeader component
        draftingHeader: {
            back: '戻る',
            backToProject: 'ホームに戻る',
            editProjectName: 'プロジェクト名を編集',
            folderUncategorized: '未分類',
            switchFolder: 'フォルダを切り替え',
            moveProjectConfirmTitle: 'プロジェクトを移動',
            moveProjectConfirmMessage: '現在のプロジェクトを選択したフォルダに移動しますか？',
            moveProjectConfirmOk: '移動',
            moveProjectConfirmCancel: 'キャンセル',
            moveProjectSuccess: 'プロジェクトを移動しました',
            moveProjectFailed: 'プロジェクトの移動に失敗しました',
            switchProject: 'プロジェクトを切り替え',
            recentProjects: '最近のプロジェクト',
            noRecentProjects: '最近のプロジェクトはありません',
            browseAllProjects: 'すべてのプロジェクトを表示',
            updateProjectNameSuccess: 'プロジェクト名が正常に更新されました',
            updateProjectNameFailed: 'プロジェクト名の更新に失敗しました',
            defaultTitle: '無題のドキュメント',
            editTitle: 'クリックしてタイトルを編集',
            clickToEditName: 'クリックして編集',
            screen: {
                single: 'シングル画面',
                split: '分割画面',
            },
            aiHiro: 'Hiro',
            save: '保存',
            saveOptions: '保存オプション',
            saveToFolder: 'フォルダに保存',
            saveSuccess: '保存が成功しました',
            saveFailed: '保存に失敗しました',
            export: 'エクスポート',
            exportAll: 'すべてエクスポート',
            exportSuccess: 'エクスポートが成功しました',
            exportFailed: 'エクスポートに失敗しました',
            settings: '設定',
            share: '共有',
            sharePermissionDenied: 'プロジェクトの作成者のみが共有できます',
            readOnlyWarning: '権限不足：読み取り専用権限のみです',
            emptyContentError: 'コンテンツが空です。保存できません',
            updateTitleSuccess: 'タイトルが正常に更新されました',
            updateTitleFailed: 'タイトルの更新に失敗しました',
            importing: 'ドキュメントをインポート中...',
            importSuccess: 'インポートが成功しました',
            importFailed: 'インポートに失敗しました',
            exportUpgradeTip: 'エクスポートは有料プランでご利用いただけます。',
            upgradeLink: 'アップグレード',
        },
        userPreferences: {
            title: '設定',
            taskDisclosure: '発明開示書',
            taskPatentDraft: '特許出願',
            taskProsecution: '拒絶理由通知対応',
            personalization: 'パーソナライズ',
            description: '今後の{taskType}タスクをガイドする Markdown 形式の永続ルールを保存します。',
            placeholder: 'ここに実行ルールを入力します。例：\n\n# ワークフロー\n\n- 要件を分析してから方案を提示する\n- 回答前に事実と形式を確認する',
            saving: '保存中...',
            saveSuccess: '設定を保存しました',
            saveFailed: '設定の保存に失敗しました',
            loadFailed: '設定の読み込みに失敗しました',
            closeConfirmTitle: '変更を破棄',
            closeConfirmMessage: '未保存の変更があります。閉じますか？',
            switchConfirmMessage: '未保存の変更があります。タスク種類を切り替えて変更を破棄しますか？',
            closeConfirmOk: '破棄',
        },
        // AddSourceDialog specific i18n
        addSource: {
            title: 'ソースを追加',
            createDocument: 'ドキュメントを作成',
            selectDocumentType: 'ドキュメントタイプを選択して作成',
        },
        // Blank document feature (patent-editor specific)
        blank: {
            tab: '空白ドキュメント',
            placeholder: '空白ドキュメントを作成',
            title: '空白ドキュメント',
            description: '空のドキュメントを作成し、ゼロから執筆を開始',
            action: '空白ドキュメントを作成',
        },
        // SourceTabs component
        sourceTabs: {
            closeOthers: '他のタブを閉じる',
            closeAll: 'すべて閉じる',
            files: 'ファイル',
            originalText: '原文',
        },
    },
};
